import {fetch} from '../utils/fetch'
import {casaApiUrl} from 'configs/casa-api'
import queryString from 'query-string'
import moment from 'moment-timezone'

function getNpsUserSegment(filter) {
  let {startDate, endDate, storeNames} = filter.toJSON();
  let startDateParam = moment(startDate).format('YYYY-MMM-DD');
  let endDateParam = moment(endDate).format('YYYY-MMM-DD');
  let query = queryString.stringify({
    stores: storeNames,
    startDate: startDateParam,
    endDate: endDateParam
  }, {arrayFormat: 'bracket'});
  return fetch(`${casaApiUrl}/users/nps/segmentation?${query}`, {
    credentials: 'include',
    method: 'GET'
  }).then(r => r.json())
}

export default {
  getNpsUserSegment
}



// WEBPACK FOOTER //
// ./src/services/nps-analytics-service.js